import actionsUsers from "./actions";

export default {
  namespaced: true,
  actions: actionsUsers,
};
